import './theme_fimlab.scss';
import ITheme from '../ITheme';
import NavigationItems from '@/navigationItems';

export default class ThemeTh implements ITheme {
    id: string = 'fimlab';
    matchIfHostNameContainsAny: string[] = ["fimlab"];
    name: string = 'fimlab';
    cssClassName: string = 'theme_fimlab';
    dark: boolean = false;
    menuDark: boolean = false;
    toolbarDark: boolean = true;
    bottomNavDark: boolean = true;
    menuRight: boolean = false;
    booking: boolean = true;
    menuNavigationItems: INavigationItem[] = [
        NavigationItems.passengers,
        NavigationItems.trips,
        NavigationItems.cancelTrips,
        NavigationItems.booking,
        NavigationItems.personalInfo,
        NavigationItems.messages,
        NavigationItems.accessibilityReport,
        NavigationItems.privacy,
    ];
    bottomNavNavigationItems: INavigationItem[] = [
        NavigationItems.booking,
        NavigationItems.trips,
        NavigationItems.cancelTrips,
        NavigationItems.messages,
    ];
    
    vuetifyTheme: any = {
        primary: '#022f49',
        secondary: '#41b6e6',
        accent: '#022f49',
        warning: 'df1995',
        bottomNavColor: '#41b6e6',
    };
}
